import { Box, xcss } from '@atlaskit/primitives';
import { useLocale } from '@databases/intl';
import { type DatabaseFieldType } from '@databases/types/database';
import { toDisplayDate } from '@databases/utils/database/field-types/date';
import React, { type FunctionComponent, useMemo } from 'react';

import { type ViewComponentProps } from './types';

const containerStyles = xcss({
  backgroundColor: 'color.background.neutral',
  borderRadius: 'radius.small',
  color: 'color.text',
  paddingBlock: 'space.025',
  paddingInline: 'space.050',
});

const disabledColorStyles = xcss({
  color: 'color.text.disabled',
});

const DateValueView: FunctionComponent<ViewComponentProps<DatabaseFieldType.DATE>> = ({
  value,
  showDisabledValue,
}) => {
  const locale = useLocale();

  const displayDate = useMemo(() => {
    if (!value) {
      return null;
    }

    let date = value;
    try {
      date = toDisplayDate(value, locale) ?? value;
      // eslint-disable-next-line canvas/no-swallow-errors-in-catch
    } catch (e) {
      /* empty */
    }

    return date;
  }, [value, locale]);

  if (!value) {
    return null;
  }

  return (
    <Box as="span" xcss={[containerStyles, showDisabledValue && disabledColorStyles]}>
      {displayDate}
    </Box>
  );
};

export default DateValueView;
